import { FormEvent, useState } from 'react'
import { Title } from '../../part/title'
import { InputWithLabel } from '../../molecules/input-with-label'
import { Button } from '../../molecules/button'
import { Lang } from '../../../translations/lang'
import { webRequest } from '../../../types/handle-api'

// 終了日（To）未確定のデフォルト。data-models.md §5。
const UNDEFINED_END_DATE = '9999-12-31'

type Props = {
  hide: () => void
  onSaved: () => void
}
export const CreateRfidDeviceValidPeriod = ({ hide, onSaved }: Props) => {
  const [macAddress, setMacAddress] = useState<string>('')
  const [startDate, setStartDate] = useState<string>('')
  const [endDate, setEndDate] = useState<string>(UNDEFINED_END_DATE)
  const [errorStatement, setErrorStatement] = useState<string>()

  async function submit(e: FormEvent) {
    e.preventDefault()
    setErrorStatement(undefined)

    const response = await webRequest('RfidDeviceValidPeriodCreate', {
      macAddress,
      startDate,
      endDate,
    })
    if (response.status === 200) {
      onSaved()
    } else if (response.status === 422 && response.data.params['startDate']) {
      setErrorStatement(Lang.inHospital.validPeriod.duplicateError)
    } else {
      setErrorStatement(Lang.inHospital.validPeriod.saveError)
    }
  }

  return (
    <div className="fixed top-0 left-0 flex justify-center items-center w-screen h-screen bg-modal-background z-50">
      <form
        className="rounded-10 p-42 bg-white w-[640px] max-h-[90%] overflow-scroll"
        onSubmit={submit}
      >
        <Title title={Lang.inHospital.validPeriod.createTitle} />
        <InputWithLabel
          required={true}
          className="mt-24"
          label={Lang.inHospital.validPeriod.macAddress}
          value={macAddress}
          onChange={setMacAddress}
        />
        <InputWithLabel
          required={true}
          type="date"
          className="mt-24"
          label={Lang.inHospital.validPeriod.startDate}
          value={startDate}
          onChange={setStartDate}
        />
        <InputWithLabel
          required={true}
          type="date"
          className="mt-24"
          label={Lang.inHospital.validPeriod.endDate}
          value={endDate}
          onChange={setEndDate}
        />
        <p className="mt-4 text-xs text-gray-500">
          {Lang.inHospital.validPeriod.endDateNote}
        </p>
        {errorStatement && (
          <p className="flex justify-center my-32 text-vixell-red text-sm">
            {errorStatement}
          </p>
        )}
        <div className="flex justify-center gap-[48px] mt-[60px]">
          <Button type="button" color="red" onClick={hide}>
            {Lang.cancel}
          </Button>
          <Button color="cyan">{Lang.register}</Button>
        </div>
      </form>
    </div>
  )
}
